import React from "react";

export default function MessageNotification(props) {
  const { counter, lastMessage } = props;
  return (
    <>
      {lastMessage === undefined || lastMessage === null ? (
        <div className="s360-messageNotification-onlyCount">
          {counter}
        </div>
      ) : (
        <div className="s360-messageNotification-countWithMessage">
          {counter}
        </div>
      )}
    </>
  );
}
